import {
    SHIPMENTLIST,
    SHIPMENTORORDERDETAILS,
    F1ORDERLIST,
    F1ORDERSEARCHLIST,
    UPDATEF1ORDERSEARCHLIST,
    F1ORDERDETAILS,
    ABNORMALRECORDLIST,
    SKU_REPLENISHMENT_DETAILS,
    SKU_INVENTORY_DETAILS,
    F1ORDER_SEARCH_FIELD,
    SHIPMENT_SEARCH_FIELD,
    F1_ORDERLIST_SEARCH_FIELD,
    F1ORDER_RECEIVE_SEARCH_FIELD,
    SAVE_F1ORDER_RECEIVE_ORDER,
    F1ORDER_RECEIVE_DETAIL,
    F1_SHIPMENT_VIEW_DATA,
    F1_SHIPMENT_WAIT_RECEIVE,
    F1_SHIPMENT_WAIT_SHIP,
    F1_SHIPMENT_RECEIVED,
    GET_USER_CENTER_ADVENT_QUANTITY,
    GET_ADVENT_PRODUCT_SC_LIST,
    ADD_ADVENT_INVENTORY_DETAIL,
    PREVIEW_ADVENT_IMAGE,
    PREVIEW_BATCH_SHIPMENT_PDF,
    GET_DELIVER_DETAILS,
    GET_SHIPPED_PACKAGE_QUANTITY,
    SCRAP_UPLOAD,
    SUPPLY_CENTER,
    ALL_SC_LIST,
    SKU_VAGUE_SEARCH,
    GET_INTERNAL_ORDER_LIST,
    GET_INTERNAL_ORDER_KIT_LIST,
    INTERNAL_ADD_ORDER_NO,
    INTERNAL_WITHDRAW,
    INTERNAL_UPDATE_NO,
    INTERNAL_RECEIVED_GOOD,
    VIEW_ON_THE_GO_PACKAGE,
    INTERNAL_TRANSFER_SEARCH_FIELD,
    GET_INTERNAL_ORDER_DETAIL,
    UPDAE_INTERNAL_ORDER_STATUS,
    INTERNAL_REDQUANTITY,
    GET_SKU_KIT_LIST_OF_INTERNAL_ORDER,
    GET_LOT_QUANTITY_OF_INTERNAL_ORDER,
    ORDER_DETAIL_MESSAGE_COUNT,
    ORDER_DETAIL_MESSAGE_LIST,
    ORDER_DETAIL_ON_KEY_READ,
    YOUR_MESSAGE_TOTAL,
    YOUR_MESSAGE_LIST,
    YOUR_MESSAGE_READ,
    F1_ORDER_LIST_REFRESH,
    GET_SCRAP_TYPE,
    CHECK_F1_NUMBER,
    E1_GET_SKU_LIST,
    GET_SCRAP_PARAMS,
    QUERY_PICK_ORDER_LIST,
    CANCEL_PICK_ORDER,
    SHIP_ORDER,
    FORCE_CANCEL_PICK_ORDER,
    BATCH_PRINT_RECOMMEND_PRODUCT_PDF,
    BATCH_PRINT_PICK_ORDER_PREVIEW_PDF,
    GET_PICK_ORDER_MESSAGE_LIST,
    ON_KEY_READ_MESSAGE,
    F1_PACKAGE_ON_THE_GO_ORDERLIST,
    UPDATE_F1_ORDER_LIST,
    UPDATE_F1_PACKAGE_ON_THE_GO_LIST,
    F1_ORDER_TAB_ACTIVE,
    YOUR_MESSAGE_TAB_ACTIVE,
    VIEW_ORDER_TRACKING,
    SET_SHIPMENTS_SOURCE,
    UPDATE_CURRENT_PAGE_NUM,
    SET_F1_ORDER_SOURCE,
    UPDATE_F1_ORDER_CURRENT_PAGE_NUM,
    SET_F1_ORDER_ON_GO_PACKAGE_SOURCE,
    UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM,
    ENTER_SALES_DELIVER_DETAIL,
    GET_FEED_BACK_LIST,
    SET_HOST_CURRENT_POSITION,
    SET_HOST_PUNCH_MAP,
    PUNCH_RECEIVABLE,
    SET_PUNCH_STATUS,
    SET_ORDER_RELATED_TASK_FLAG,
    SET_CURRENT_SHIPMENT_ID,
    UPDATE_SHIPMENT_LIST,
    SET_REVOKE_PACKAGE,
    UPDATE_YOUR_MESSAGE_LIST,
    B2B_CASMART_SHIPMENT,
    UPDATE_SHIPMENTORORDERDETAIL,
    UPDATE_SHIPMENT_LIST_TAB,
    UPDATE_F1_ONGO_PACKAGE_SORT,
    SET_CURRENT_ST_NUMBER,
    GET_F1_MESSAGE_LIST,
    CLEARE_F1_PACKAGE_DATA,
    GET_RECEIVING_CODE,
    PREVIEW_PROXY_DELIVERY_IMAGE,
} from 'Actions/host';
import update from 'immutability-helper';
import {F1_PACKAGE_SORT} from 'Utils/constant';

let initialState = {
    shipmentList: {
        tobeShip: [],
        onHold: [],
        receive: [],
        complete: [],
    },
    shipmentOrOrderDetails: {},
    myOrderPickDetails: {},
    skuInventoryDetails: [],
    F1OrderList: [],
    F1PackageOnTheGoList: [],
    F1OrderSearchList: [],
    F1OrderDetails: {},
    updateF1OrderList: {},
    abnormalRecordList: [],
    pageSize: 10,
    skuReplenishmentDetail: {},
    tabActive: 0,
    messageTabActive: 0,
    enterSalesDeliverDetails: false,
    F1OrderSearchfields: {
        queryKey: '',
    },
    shipmentSearchfields: {
        queryKey: '',
    },
    f1OrderReceiveSearchfields: {
        queryKey: '',
    },
    f1OrderListSearchfields: {
        queryKey: '',
    },
    internalTransferSearchfields: {
        queryKey: '',
    },
    f1ShipmentViewData: {},
    receivingCodeData: {},
    f1ShipmentWaitReceive: {},
    f1ShipmentWaitshipped: {},
    f1ShipmentReceived: {},
    userCenterAdventQuantitys: {},
    adventProductsSCList: [],
    adventInventoryDetails: [],
    previewData: {},
    previewProxyDeliveryImage: {},
    deliverDetails: {},
    packageQuantity: {},
    supplyCenterlist: {},
    supplyCenterAlllist: {},
    skuVagueSearchData: {},
    internalOrderList: {
        OUT: [],
        IN: [],
    },
    internalOrderKitList: {},
    internalOrderDetail: null,
    internalOrderStatus: 'SHIPPED',
    skuKitListOfInternalOrder: [],
    lotQuantityOfInternalOrder: [],
    orderDetailMessageCount: {},
    orderDetailMessageList: [],
    f1MessageList: [],
    onKeyReadMessage: {},
    yourMassageList: {},
    scrapType: {},
    expressNumberList: {},
    scrapSkuList: {},
    scrapParamsList: {},
    batchShipmentData: {},
    batchRecommendProductData: {},
    batchPrintPickOrderData: {},
    pickOrderMessageList: [],
    viewOnTheGoPackageList: {},
    viewOrderTrackingData: {},
    fromShipmentDetails: false,
    revokePackageSuccessFlag: false,
    currentPageNum: 0,
    fromF1OrderDetails: false,
    currentF1OrderPageNum: 0,
    fromF1OrderOnGoPackageDetails: false,
    currentF1OrderOnGoPackagePageNum: 0,
    customerFeedbackList: [],
    hostPosition: [],
    hostPunchMap: {},
    punchStatusFlag: false,
    currentShipmentId: '',
    shipmentTab: 'tobeShip',
    f1OngoPackageIsAsc: F1_PACKAGE_SORT.ASC_SORT,
    orderRelatedTaskFlag: false,
    currentStNumber: '',
};

export function host(state = initialState, action) {
    let payload = {};
    switch (action.type) {
        case SHIPMENTLIST:
            payload.shipmentList = {};

            if (action.payload.tab === state.shipmentTab) {
                if (action.payload.pageNum <= 1) {
                    payload.shipmentList[action.payload.tab] =
                        action.payload.data;
                } else {
                    payload.shipmentList[action.payload.tab] =
                        state.shipmentList[action.payload.tab].concat(
                            action.payload.data,
                        );
                }
                return {...state, ...payload};
            } else {
                payload.shipmentList[state.shipmentTab] =
                    state.shipmentList[state.shipmentTab];
                return {...state, ...payload};
            }

        case UPDATE_SHIPMENT_LIST_TAB:
            return update(state, {shipmentTab: action.payload});

        case SHIPMENT_SEARCH_FIELD:
            return update(state, {shipmentSearchfields: action.payload});
        case F1_ORDERLIST_SEARCH_FIELD:
            return update(state, {f1OrderListSearchfields: action.payload});
        case SHIPMENTORORDERDETAILS:
            payload.shipmentOrOrderDetails = action.payload;
            return {...state, ...payload};
        case SKU_INVENTORY_DETAILS:
            payload.skuInventoryDetails = action.payload;
            return {...state, ...payload};
        case F1ORDERLIST:
            if (action.payload.pageNum <= 1) {
                payload.F1OrderList = action.payload.data;
            } else {
                payload.F1OrderList = state.F1OrderList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case UPDATE_F1_ORDER_LIST:
            payload.F1OrderList = action.payload;
            return {...state, ...payload};
        case UPDATE_F1_PACKAGE_ON_THE_GO_LIST:
            payload.F1PackageOnTheGoList = action.payload;
            return {...state, ...payload};
        case UPDATE_YOUR_MESSAGE_LIST:
            payload.yourMassageList = action.payload;
            return {...state, ...payload};
        case F1_ORDER_TAB_ACTIVE:
            return update(state, {tabActive: action.payload});
        case YOUR_MESSAGE_TAB_ACTIVE:
            return update(state, {messageTabActive: action.payload});
        case ENTER_SALES_DELIVER_DETAIL:
            return update(state, {enterSalesDeliverDetails: action.payload});
        case F1_PACKAGE_ON_THE_GO_ORDERLIST:
            if (action.payload.pageNum <= 1) {
                payload.F1PackageOnTheGoList = action.payload.data;
            } else {
                payload.F1PackageOnTheGoList =
                    state.F1PackageOnTheGoList.concat(action.payload.data);
            }
            return {...state, ...payload};
        case VIEW_ORDER_TRACKING:
            payload.viewOrderTrackingData = action.payload;
            return {...state, ...payload};
        case F1ORDER_SEARCH_FIELD:
            return update(state, {F1OrderSearchfields: action.payload});
        case F1ORDER_RECEIVE_SEARCH_FIELD:
            return update(state, {f1OrderReceiveSearchfields: action.payload});
        case INTERNAL_TRANSFER_SEARCH_FIELD:
            return update(state, {
                internalTransferSearchfields: action.payload,
            });
        case SAVE_F1ORDER_RECEIVE_ORDER:
            return update(state, {updateF1OrderList: action.payload});
        case F1ORDER_RECEIVE_DETAIL:
            return update(state, {F1OrderDetails: action.payload});
        case UPDATEF1ORDERSEARCHLIST:
            payload.F1OrderSearchList = action.payload;

            return {...state, ...payload};
        case F1ORDERSEARCHLIST:
            if (action.payload.pageNum <= 1) {
                payload.F1OrderSearchList = action.payload.data;
            } else {
                payload.F1OrderSearchList = state.F1OrderSearchList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case F1ORDERDETAILS:
            // case SAVE_F1ORDER_RECEIVE_ORDER:
            payload.F1OrderDetails = action.payload;
            return {...state, ...payload};
        case F1_SHIPMENT_VIEW_DATA:
            payload.f1ShipmentViewData = action.payload;
            return {...state, ...payload};
        case F1_SHIPMENT_WAIT_RECEIVE:
            payload.f1ShipmentWaitReceive = action.payload;
            return {...state, ...payload};
        case F1_SHIPMENT_WAIT_SHIP:
            payload.f1ShipmentWaitshipped = action.payload;
            return {...state, ...payload};
        case F1_SHIPMENT_RECEIVED:
            payload.f1ShipmentReceived = action.payload;
            return {...state, ...payload};
        case SKU_REPLENISHMENT_DETAILS:
            payload.skuReplenishmentDetail = action.payload;
            return {...state, ...payload};
        case ABNORMALRECORDLIST:
            if (action.payload.pageNum <= 1) {
                payload.abnormalRecordList = action.payload.data;
            } else {
                payload.abnormalRecordList = state.abnormalRecordList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case GET_USER_CENTER_ADVENT_QUANTITY:
            payload.userCenterAdventQuantitys = {};
            payload.userCenterAdventQuantitys = action.payload;
            return {...state, ...payload};
        // return update(state, { userCenterAdventQuantitys: action.payload });
        case GET_ADVENT_PRODUCT_SC_LIST:
            payload.adventProductsSCList = action.payload;
            return {...state, ...payload};
        case ADD_ADVENT_INVENTORY_DETAIL:
            payload.adventInventoryDetails = action.payload;
            return {...state, ...payload};

        case PREVIEW_ADVENT_IMAGE:
            payload.previewData = action.payload;
            return {...state, ...payload};
        case PREVIEW_PROXY_DELIVERY_IMAGE:
            payload.previewProxyDeliveryImage = action.payload;
            return {...state, ...payload};
        case PREVIEW_BATCH_SHIPMENT_PDF:
            payload.batchShipmentData = action.payload;
            return {...state, ...payload};
        case BATCH_PRINT_RECOMMEND_PRODUCT_PDF:
            payload.batchRecommendProductData = action.payload;
            return {...state, ...payload};
        case BATCH_PRINT_PICK_ORDER_PREVIEW_PDF:
            payload.batchPrintPickOrderData = action.payload;
            return {...state, ...payload};
        case GET_DELIVER_DETAILS:
            payload.deliverDetails = action.payload.data;
            return {...state, ...payload};

        case GET_SHIPPED_PACKAGE_QUANTITY:
            payload.packageQuantity = action.payload;
            return {...state, ...payload};
        case SCRAP_UPLOAD:
        case SUPPLY_CENTER:
            payload.supplyCenterlist = action.payload;
            return {...state, ...payload};
        case GET_PICK_ORDER_MESSAGE_LIST:
            payload.pickOrderMessageList = action.payload;
            return {...state, ...payload};
        case ALL_SC_LIST:
            payload.supplyCenterAlllist = action.payload;
            return {...state, ...payload};
        case SKU_VAGUE_SEARCH:
            payload.skuVagueSearchData = action.payload;
            return {...state, ...payload};
        case GET_INTERNAL_ORDER_LIST:
            payload.internalOrderList = {};
            if (action.payload.pageNum <= 1) {
                payload.internalOrderList[action.payload.tab] =
                    action.payload.data;
            } else {
                payload.internalOrderList[action.payload.tab] =
                    state.internalOrderList[action.payload.tab].concat(
                        action.payload.data,
                    );
            }
            return {...state, ...payload};
        case GET_INTERNAL_ORDER_KIT_LIST:
            payload.internalOrderKitList = action.payload;
            return {...state, ...payload};
        case INTERNAL_ADD_ORDER_NO:
        case INTERNAL_WITHDRAW:
        case INTERNAL_UPDATE_NO:
        case INTERNAL_RECEIVED_GOOD:
        case YOUR_MESSAGE_TOTAL:
        case YOUR_MESSAGE_READ:
        case F1_ORDER_LIST_REFRESH:
        case CANCEL_PICK_ORDER:
        case SHIP_ORDER:
        case FORCE_CANCEL_PICK_ORDER:
        case ON_KEY_READ_MESSAGE:
        case PUNCH_RECEIVABLE:
        case B2B_CASMART_SHIPMENT:
            return {...state, ...payload};
        case VIEW_ON_THE_GO_PACKAGE:
            payload.viewOnTheGoPackageList = action.payload;
            return {...state, ...payload};
        case GET_INTERNAL_ORDER_DETAIL:
            payload.internalOrderDetail = action.payload;
            payload.internalOrderStatus = 'SHIPPED';
            return {...state, ...payload};
        case UPDAE_INTERNAL_ORDER_STATUS:
            payload.internalOrderStatus = action.payload;
            return {...state, ...payload};
        case INTERNAL_REDQUANTITY:
            return {...state, ...payload};

        case GET_SKU_KIT_LIST_OF_INTERNAL_ORDER:
            payload.skuKitListOfInternalOrder = action.payload;
            return {...state, ...payload};
        case GET_LOT_QUANTITY_OF_INTERNAL_ORDER:
            payload.lotQuantityOfInternalOrder = action.payload;
            return {...state, ...payload};
        case ORDER_DETAIL_MESSAGE_COUNT:
            payload.orderDetailMessageCount = action.payload;
            return {...state, ...payload};

        case ORDER_DETAIL_MESSAGE_LIST:
            payload.orderDetailMessageList = action.payload;
            return {...state, ...payload};

        case GET_F1_MESSAGE_LIST:
            payload.f1MessageList = action.payload;
            return {...state, ...payload};

        case CLEARE_F1_PACKAGE_DATA:
            payload.f1MessageList = [];
            payload.viewOnTheGoPackageList = {};
            return {...state, ...payload};

        case E1_GET_SKU_LIST:
            payload.scrapSkuList = action.payload;
            return {...state, ...payload};
        case GET_SCRAP_PARAMS:
            payload.scrapParamsList = action.payload;
            return {...state, ...payload};
        case ORDER_DETAIL_ON_KEY_READ:
            payload.onKeyReadMessage = action.payload;
            return {...state, ...payload};
        case GET_SCRAP_TYPE:
            payload.scrapType = action.payload;
            return {...state, ...payload};
        case CHECK_F1_NUMBER:
            payload.expressNumberList = action.payload;
            return {...state, ...payload};
        case YOUR_MESSAGE_LIST:
            if (action.payload.pageNum <= 1) {
                payload.yourMassageList = action.payload.data;
            } else {
                payload.yourMassageList = state.yourMassageList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case QUERY_PICK_ORDER_LIST:
            payload.myOrderPickDetails = action.payload;
            return {...state, ...payload};
        case SET_SHIPMENTS_SOURCE:
            return update(state, {fromShipmentDetails: action.payload});
        case SET_REVOKE_PACKAGE:
            return update(state, {revokePackageSuccessFlag: action.payload});
        case SET_PUNCH_STATUS:
            return update(state, {punchStatusFlag: action.payload});

        case SET_ORDER_RELATED_TASK_FLAG:
            return update(state, {orderRelatedTaskFlag: action.payload});

        case SET_CURRENT_SHIPMENT_ID:
            return update(state, {currentShipmentId: action.payload});

        case SET_CURRENT_ST_NUMBER:
            return update(state, {currentStNumber: action.payload});

        case UPDATE_SHIPMENT_LIST:
            payload.shipmentList = {};
            let currentTab = action.payload.tab;
            let currentShipmentList = action.payload.currentShipmentList;
            payload.shipmentList[currentTab] = currentShipmentList;

            return {...state, ...payload};
        case UPDATE_CURRENT_PAGE_NUM:
            return update(state, {currentPageNum: action.payload});
        case SET_F1_ORDER_SOURCE:
            return update(state, {fromF1OrderDetails: action.payload});
        case UPDATE_F1_ORDER_CURRENT_PAGE_NUM:
            return update(state, {currentF1OrderPageNum: action.payload});
        case SET_F1_ORDER_ON_GO_PACKAGE_SOURCE:
            return update(state, {
                fromF1OrderOnGoPackageDetails: action.payload,
            });
        case UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM:
            return update(state, {
                currentF1OrderOnGoPackagePageNum: action.payload,
            });

        case UPDATE_F1_ONGO_PACKAGE_SORT:
            return update(state, {
                f1OngoPackageIsAsc: action.payload,
            });

        case SET_HOST_CURRENT_POSITION:
            payload.hostPosition = action.payload;
            return {...state, ...payload};
        case SET_HOST_PUNCH_MAP:
            payload.hostPunchMap = action.payload;
            return {...state, ...payload};
        case GET_FEED_BACK_LIST:
            payload.customerFeedbackList = action.payload;
            return {...state, ...payload};

        case UPDATE_SHIPMENTORORDERDETAIL:
            console.log(
                'shipmentOrOrderDetails===============================',
                action.payload,
            );
            return update(state, {shipmentOrOrderDetails: action.payload});
        case GET_RECEIVING_CODE:
            payload.receivingCodeData = action.payload;
            return {...state, ...payload};
        default:
            return state;
    }
}
